import Vue from 'vue';
import Router from 'vue-router';
import {pageKey} from './pageKey';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      component: () => {
        return import('./views/index');
      }
    },
    {
      path: '/home',
      component: () => {
        return import('./views/home');
      }
    },
    {
      path: '/auth',
      component: () => {
        return import('./views/auth');
      }
    },
    {
      path: '/receive-code-failed',
      component: () => {
        return import('./views/receive-code-failed');
      }
    },
    {
      path: '/status/checking',
      component: () => {
        return import('./views/status/checking');
      }
    },
    {
      path: '/status/checking-end',
      component: () => {
        return import('./views/status/checking-end');
      }
    },
    {
      path: '/status/success',
      component: () => {
        return import('./views/status/success');
      }
    },
    {
      path: '/status/failed',
      component: () => {
        return import('./views/status/failed');
      }
    },
    {
      path: '/insurance',
      component: () => {
        return import('./views/insurance/insurance');
      }
    },
    {
      path: '/insurance/empty',
      component: () => {
        return import('./views/insurance/empty');
      }
    },
    {
      path: '/insurance/handling',
      component: () => {
        return import('./views/insurance/handling');
      }
    },
    {
      path: '/insurance/receive-success',
      component: () => {
        return import('./views/insurance/receive-success');
      }
    },
    {
      path: '/guide',
      component: () => {
        return import('./views/guide/guide');
      }
    }
  ]
});

router.afterEach(function (to, from) {
  if (window.__qd__ && window.__qd__.page) {
    window.__qd__.page(to.fullPath, from.fullPath);
  }
  
  let PAGEKEY = pageKey[to.path];
  let fromPAGEKEY = pageKey[from.path];
  try {
    if (window.$psa) {
      if (PAGEKEY) window.$psa(PAGEKEY).pagePush(window.PSAPROJECTID, PAGEKEY);
      if (fromPAGEKEY) window.$psa(fromPAGEKEY).pageLeave(window.PSAPROJECTID, fromPAGEKEY);
    }
  } catch (e) {
    console.error('没有获取到psa方法');
  }
});

export default router;
